<template>
    <div class="venue-add-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/venueList' }">
                    <i class="el-icon-office-building"></i>展馆列表
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ isEdit ? '编辑展馆' : '新增展馆' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-circle-plus-outline"></i>
                    <span>{{ isEdit ? '编辑展馆' : '新增展馆' }}</span>
                </div>
                <div class="header-actions">
                    <el-button size="mini" icon="el-icon-back" @click="goBack">返回</el-button>
                </div>
            </div>

            <!-- 表单内容 -->
            <div class="form-container">
                <el-form
                        ref="venueForm"
                        :model="form"
                        :rules="rules"
                        label-width="120px"
                        size="mini"
                        :disabled="loading"
                >
                    <!-- 基本信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-info"></i>
                            </div>
                            <div class="section-title">基本信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="展馆名称" prop="title">
                                    <el-input
                                            v-model="form.title"
                                            placeholder="请输入展馆名称"
                                            maxlength="50"
                                            show-word-limit
                                            prefix-icon="el-icon-edit"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="展馆分类" prop="category_id">
                                    <el-select
                                            v-model="form.category_id"
                                            placeholder="请选择展馆分类"
                                            filterable
                                            clearable
                                            style="width: 100%"
                                    >
                                        <el-option
                                                v-for="item in categoryList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="展馆状态" prop="status">
                                    <el-radio-group v-model="form.status">
                                        <el-radio :label="0">维护中</el-radio>
                                        <el-radio :label="1">营业中</el-radio>
                                        <el-radio :label="2">已关闭</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="展馆等级" prop="level">
                                    <el-select
                                            v-model="form.level"
                                            placeholder="请选择展馆等级"
                                            style="width: 100%"
                                    >
                                        <el-option label="一级展馆" value="1"></el-option>
                                        <el-option label="二级展馆" value="2"></el-option>
                                        <el-option label="三级展馆" value="3"></el-option>
                                        <el-option label="特级展馆" value="4"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="展馆描述" prop="description">
                                    <el-input
                                            v-model="form.description"
                                            type="textarea"
                                            :rows="3"
                                            placeholder="请输入展馆描述"
                                            maxlength="300"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 位置信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-location-information"></i>
                            </div>
                            <div class="section-title">位置信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="所在省份" prop="province_id">
                                    <el-select
                                            v-model="form.province_id"
                                            placeholder="请选择省份"
                                            filterable
                                            clearable
                                            style="width: 100%"
                                            @change="handleProvinceChange"
                                    >
                                        <el-option
                                                v-for="item in provinceList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="所在城市" prop="city_id">
                                    <el-select
                                            v-model="form.city_id"
                                            placeholder="请选择城市"
                                            filterable
                                            clearable
                                            style="width: 100%"
                                            @change="handleCityChange"
                                    >
                                        <el-option
                                                v-for="item in cityList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="详细地址" prop="address">
                                    <el-input
                                            v-model="form.address"
                                            placeholder="请输入详细地址"
                                            prefix-icon="el-icon-location"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="经度" prop="longitude">
                                    <el-input
                                            v-model="form.longitude"
                                            placeholder="请输入经度"
                                            type="number"
                                            step="0.000001"
                                    >
                                        <template slot="append">°</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="纬度" prop="latitude">
                                    <el-input
                                            v-model="form.latitude"
                                            placeholder="请输入纬度"
                                            type="number"
                                            step="0.000001"
                                    >
                                        <template slot="append">°</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 规模信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-s-data"></i>
                            </div>
                            <div class="section-title">规模信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="8">
                                <el-form-item label="展馆面积" prop="area">
                                    <el-input
                                            v-model="form.area"
                                            placeholder="展馆总面积"
                                            type="number"
                                            min="0"
                                    >
                                        <template slot="append">㎡</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="容纳人数" prop="capacity">
                                    <el-input-number
                                            v-model="form.capacity"
                                            :min="0"
                                            :max="1000000"
                                            placeholder="最大容纳人数"
                                            style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="展厅数量" prop="hall_count">
                                    <el-input-number
                                            v-model="form.hall_count"
                                            :min="0"
                                            :max="100"
                                            placeholder="展厅总数"
                                            style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="8">
                                <el-form-item label="层高" prop="ceiling_height">
                                    <el-input
                                            v-model="form.ceiling_height"
                                            placeholder="展馆层高"
                                            type="number"
                                            min="0"
                                            step="0.1"
                                    >
                                        <template slot="append">米</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="最大承重" prop="max_load">
                                    <el-input
                                            v-model="form.max_load"
                                            placeholder="地面最大承重"
                                            type="number"
                                            min="0"
                                            step="0.1"
                                    >
                                        <template slot="append">吨/㎡</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="柱间距" prop="column_spacing">
                                    <el-input
                                            v-model="form.column_spacing"
                                            placeholder="柱子间距"
                                            type="number"
                                            min="0"
                                            step="0.1"
                                    >
                                        <template slot="append">米</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 设施信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-s-tools"></i>
                            </div>
                            <div class="section-title">设施信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="基础设施">
                                    <el-checkbox-group v-model="form.facilities" class="facilities-group">
                                        <el-checkbox
                                                v-for="facility in facilitiesList"
                                                :key="facility.value"
                                                :label="facility.value"
                                                class="facility-checkbox"
                                        >
                                            <div class="facility-item">
                                                <i :class="facility.icon"></i>
                                                <span>{{ facility.label }}</span>
                                            </div>
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="停车位数量" prop="parking_spaces">
                                    <el-input-number
                                            v-model="form.parking_spaces"
                                            :min="0"
                                            :max="10000"
                                            placeholder="停车位总数"
                                            style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="会议室数量" prop="meeting_rooms">
                                    <el-input-number
                                            v-model="form.meeting_rooms"
                                            :min="0"
                                            :max="100"
                                            placeholder="会议室总数"
                                            style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 联系信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-phone"></i>
                            </div>
                            <div class="section-title">联系信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="联系电话" prop="phone">
                                    <el-input
                                            v-model="form.phone"
                                            placeholder="请输入联系电话"
                                            prefix-icon="el-icon-phone"
                                            maxlength="20"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系人" prop="contact_person">
                                    <el-input
                                            v-model="form.contact_person"
                                            placeholder="请输入联系人姓名"
                                            prefix-icon="el-icon-user"
                                            maxlength="20"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="邮箱地址" prop="email">
                                    <el-input
                                            v-model="form.email"
                                            placeholder="请输入邮箱地址"
                                            prefix-icon="el-icon-message"
                                            type="email"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="官方网站" prop="website">
                                    <el-input
                                            v-model="form.website"
                                            placeholder="请输入官方网站"
                                            prefix-icon="el-icon-link"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 图片信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-picture"></i>
                            </div>
                            <div class="section-title">图片信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="封面图片" prop="cover_image">
                                    <el-upload
                                            class="cover-upload"
                                            action="/api/upload"
                                            :headers="uploadHeaders"
                                            :on-success="handleCoverImageSuccess"
                                            :on-remove="handleCoverImageRemove"
                                            :before-upload="beforeImageUpload"
                                            :file-list="coverImageList"
                                            list-type="picture-card"
                                            :limit="1"
                                    >
                                        <i class="el-icon-plus"></i>
                                        <div slot="tip" class="el-upload__tip">建议尺寸 800x400px，支持 JPG/PNG 格式，大小不超过 2MB</div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="展馆图集" prop="gallery_images">
                                    <el-upload
                                            class="gallery-upload"
                                            action="/api/upload"
                                            :headers="uploadHeaders"
                                            :on-success="handleGalleryImageSuccess"
                                            :on-remove="handleGalleryImageRemove"
                                            :before-upload="beforeImageUpload"
                                            :file-list="galleryImageList"
                                            list-type="picture-card"
                                            :limit="10"
                                            multiple
                                    >
                                        <i class="el-icon-plus"></i>
                                        <div slot="tip" class="el-upload__tip">最多上传10张图片，每张不超过2MB</div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="平面图纸" prop="layout_images">
                                    <el-upload
                                            class="layout-upload"
                                            action="/api/upload"
                                            :headers="uploadHeaders"
                                            :on-success="handleLayoutImageSuccess"
                                            :on-remove="handleLayoutImageRemove"
                                            :before-upload="beforeImageUpload"
                                            :file-list="layoutImageList"
                                            list-type="picture-card"
                                            :limit="5"
                                            multiple
                                    >
                                        <i class="el-icon-plus"></i>
                                        <div slot="tip" class="el-upload__tip">上传平面图纸，支持 JPG/PNG 格式，每张不超过 5MB</div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 详细信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-document"></i>
                            </div>
                            <div class="section-title">详细信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="交通指南" prop="transportation">
                                    <el-input
                                            v-model="form.transportation"
                                            type="textarea"
                                            :rows="3"
                                            placeholder="请输入交通指南信息"
                                            maxlength="500"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="周边设施" prop="surrounding_facilities">
                                    <el-input
                                            v-model="form.surrounding_facilities"
                                            type="textarea"
                                            :rows="3"
                                            placeholder="请输入周边设施信息"
                                            maxlength="300"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="注意事项" prop="notes">
                                    <el-input
                                            v-model="form.notes"
                                            type="textarea"
                                            :rows="3"
                                            placeholder="请输入注意事项"
                                            maxlength="300"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 操作按钮 -->
                    <div class="form-actions">
                        <el-button
                                size="mini"
                                @click="goBack"
                                class="cancel-btn"
                        >
                            <i class="el-icon-close"></i>取消
                        </el-button>
                        <el-button
                                size="mini"
                                type="primary"
                                :loading="loading"
                                @click="submitForm"
                                class="submit-btn"
                        >
                            <i class="el-icon-check"></i>{{ isEdit ? '更新展馆' : '保存展馆' }}
                        </el-button>
                        <el-button
                                size="mini"
                                @click="resetForm"
                                class="reset-btn"
                        >
                            <i class="el-icon-refresh"></i>重置
                        </el-button>
                    </div>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "VenueAdd",
        data() {
            return {
                loading: false,
                isEdit: false,
                venueId: null,

                // 表单数据
                form: {
                    title: '',
                    category_id: '',
                    status: 1,
                    level: '',
                    description: '',
                    province_id: '',
                    city_id: '',
                    address: '',
                    longitude: '',
                    latitude: '',
                    area: '',
                    capacity: 0,
                    hall_count: 0,
                    ceiling_height: '',
                    max_load: '',
                    column_spacing: '',
                    facilities: [],
                    parking_spaces: 0,
                    meeting_rooms: 0,
                    phone: '',
                    contact_person: '',
                    email: '',
                    website: '',
                    cover_image: '',
                    gallery_images: [],
                    layout_images: [],
                    transportation: '',
                    surrounding_facilities: '',
                    notes: ''
                },

                // 表单验证规则
                rules: {
                    title: [
                        { required: true, message: '请输入展馆名称', trigger: 'blur' },
                        { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                    ],
                    category_id: [
                        { required: true, message: '请选择展馆分类', trigger: 'change' }
                    ],
                    province_id: [
                        { required: true, message: '请选择省份', trigger: 'change' }
                    ],
                    city_id: [
                        { required: true, message: '请选择城市', trigger: 'change' }
                    ],
                    address: [
                        { required: true, message: '请输入详细地址', trigger: 'blur' }
                    ],
                    area: [
                        { required: true, message: '请输入展馆面积', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '请输入联系电话', trigger: 'blur' }
                    ]
                },

                // 分类列表
                categoryList: [
                    { id: 1, name: '综合展馆' },
                    { id: 2, name: '专业展馆' },
                    { id: 3, name: '会议中心' },
                    { id: 4, name: '展览中心' },
                    { id: 5, name: '会展中心' }
                ],

                // 省份列表
                provinceList: [
                    { id: 1, name: '北京市' },
                    { id: 2, name: '上海市' },
                    { id: 3, name: '广东省' },
                    { id: 4, name: '江苏省' },
                    { id: 5, name: '浙江省' }
                ],

                // 城市列表
                cityList: [],

                // 设施列表
                facilitiesList: [
                    { label: '空调系统', value: 'air_conditioning', icon: 'el-icon-cold-drink' },
                    { label: '中央供暖', value: 'heating', icon: 'el-icon-sunny' },
                    { label: 'WiFi覆盖', value: 'wifi', icon: 'el-icon-wifi' },
                    { label: '停车场', value: 'parking', icon: 'el-icon-position' },
                    { label: '餐饮服务', value: 'catering', icon: 'el-icon-food' },
                    { label: '安保服务', value: 'security', icon: 'el-icon-lock' },
                    { label: '物流服务', value: 'logistics', icon: 'el-icon-truck' },
                    { label: '电力供应', value: 'power', icon: 'el-icon-lightning' },
                    { label: '网络接口', value: 'network', icon: 'el-icon-connection' },
                    { label: '音响系统', value: 'sound_system', icon: 'el-icon-microphone' },
                    { label: '灯光系统', value: 'lighting', icon: 'el-icon-light' },
                    { label: '电梯', value: 'elevator', icon: 'el-icon-sort-up' },
                    { label: '无障碍设施', value: 'accessibility', icon: 'el-icon-wheelchair' },
                    { label: '储物柜', value: 'locker', icon: 'el-icon-box' },
                    { label: '休息区', value: 'rest_area', icon: 'el-icon-coffee-cup' }
                ],

                // 上传相关
                uploadHeaders: {
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                },
                coverImageList: [],
                galleryImageList: [],
                layoutImageList: []
            };
        },
        created() {
            // 判断是编辑模式还是新增模式
            this.venueId = this.$route.query.id;
            this.isEdit = !!this.venueId;

            // 初始化数据
            this.getCategoryList();
            this.getProvinceList();

            // 如果是编辑模式，获取展馆详情
            if (this.isEdit) {
                this.getVenueDetail();
            }
        },
        methods: {
            // 获取展馆详情
            getVenueDetail() {
                this.loading = true;
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    id: this.venueId
                }

                this.$axios.venueDetail(param).then(res => {
                    this.loading = false;
                    if (res.code == 200) {
                        const data = res.data;
                        // 填充表单数据
                        Object.keys(this.form).forEach(key => {
                            if (data[key] !== undefined && data[key] !== null) {
                                this.form[key] = data[key];
                            }
                        });

                        // 处理设施数据（如果是字符串需要转换为数组）
                        if (typeof this.form.facilities === 'string') {
                            this.form.facilities = this.form.facilities.split(',');
                        }

                        // 处理图片
                        if (this.form.cover_image) {
                            this.coverImageList = [{
                                name: '封面图片',
                                url: this.form.cover_image
                            }];
                        }

                        if (this.form.gallery_images && this.form.gallery_images.length > 0) {
                            this.galleryImageList = this.form.gallery_images.map((url, index) => ({
                                name: `展馆图片${index + 1}`,
                                url: url
                            }));
                        }

                        if (this.form.layout_images && this.form.layout_images.length > 0) {
                            this.layoutImageList = this.form.layout_images.map((url, index) => ({
                                name: `平面图${index + 1}`,
                                url: url
                            }));
                        }
                    } else {
                        this.$message.error(res.msg || '获取展馆详情失败');
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error('获取展馆详情失败');
                })
            },

            // 获取分类列表
            getCategoryList() {
                // 模拟API调用
                // const param = {
                //     company_id: sessionStorage.getItem('company_id'),
                //     access_token: sessionStorage.getItem('token')
                // }

                // 这里应该调用实际的API
                // this.$axios.categoryList(param).then(res => {
                //   if (res.code == 200) {
                //     this.categoryList = res.data.data || [];
                //   }
                // })
            },

            // 获取省份列表
            getProvinceList() {
                // 模拟API调用
                // const param = {
                //     company_id: sessionStorage.getItem('company_id'),
                //     access_token: sessionStorage.getItem('token')
                // }

                // 这里应该调用实际的API
                // this.$axios.provinceList(param).then(res => {
                //   if (res.code == 200) {
                //     this.provinceList = res.data.data || [];
                //   }
                // })
            },

            // 处理省份选择变化
            handleProvinceChange(provinceId) {
                if (provinceId) {
                    // 模拟获取城市列表
                    this.cityList = [
                        { id: 1, name: '北京市' },
                        { id: 2, name: '朝阳区' },
                        { id: 3, name: '海淀区' },
                        { id: 4, name: '西城区' },
                        { id: 5, name: '东城区' }
                    ];

                    // 这里应该调用实际的API获取城市列表
                    // this.$axios.cityList({ province_id: provinceId }).then(res => {
                    //   if (res.code == 200) {
                    //     this.cityList = res.data.data || [];
                    //   }
                    // })
                } else {
                    this.cityList = [];
                    this.form.city_id = '';
                }
            },

            // 处理城市选择变化
            handleCityChange(cityId) {
                // 可以在这里处理城市选择后的逻辑
                console.log('选择的城市ID:', cityId);
            },

            // 图片上传前的验证
            beforeImageUpload(file) {
                const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPGorPNG) {
                    this.$message.error('上传图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isJPGorPNG && isLt2M;
            },

            // 封面图片上传成功
            handleCoverImageSuccess(response) {
                if (response.code === 200) {
                    this.form.cover_image = response.data.url;
                    this.$message.success('封面图片上传成功');
                } else {
                    this.$message.error(response.msg || '上传失败');
                }
            },

            // 移除封面图片
            handleCoverImageRemove() {
                this.form.cover_image = '';
                this.coverImageList = [];
            },

            // 图集图片上传成功
            handleGalleryImageSuccess(response) {
                if (response.code === 200) {
                    this.form.gallery_images.push(response.data.url);
                    this.$message.success('图片上传成功');
                } else {
                    this.$message.error(response.msg || '上传失败');
                }
            },

            // 移除图集图片
            handleGalleryImageRemove(file) {
                const url = file.url || file.response.data.url;
                this.form.gallery_images = this.form.gallery_images.filter(item => item !== url);
                this.galleryImageList = this.galleryImageList.filter(item => item.url !== url);
            },

            // 平面图上传成功
            handleLayoutImageSuccess(response) {
                if (response.code === 200) {
                    this.form.layout_images.push(response.data.url);
                    this.$message.success('平面图上传成功');
                } else {
                    this.$message.error(response.msg || '上传失败');
                }
            },

            // 移除平面图
            handleLayoutImageRemove(file) {
                const url = file.url || file.response.data.url;
                this.form.layout_images = this.form.layout_images.filter(item => item !== url);
                this.layoutImageList = this.layoutImageList.filter(item => item.url !== url);
            },

            // 提交表单
            submitForm() {
                this.$refs.venueForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;

                        // 准备提交数据
                        const submitData = {
                            ...this.form,
                            company_id: sessionStorage.getItem('company_id'),
                            access_token: sessionStorage.getItem('token'),
                            operator_id: sessionStorage.getItem('user_id')
                        };

                        let apiCall;
                        if (this.isEdit) {
                            // 编辑模式，添加ID
                            submitData.id = this.venueId;
                            apiCall = this.$axios.venueSave(submitData);
                        } else {
                            // 新增模式
                            apiCall = this.$axios.venueSave(submitData);
                        }
                        apiCall.then(res => {
                            this.loading = false;
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.$router.push('/venueList');
                            } else {
                                this.$message.error(res.msg || '保存失败');
                            }
                        }).catch(error => {
                            this.loading = false;
                            console.log(error);
                            this.$message.error('保存失败，请稍后重试');
                        });

                    } else {
                        this.$message.warning('请完善表单信息');
                        return false;
                    }
                });
            },

            // 重置表单
            resetForm() {
                if (this.isEdit) {
                    // 编辑模式下重置为原始数据
                    this.getVenueDetail();
                } else {
                    // 新增模式下清空表单
                    this.$refs.venueForm.resetFields();
                    this.coverImageList = [];
                    this.galleryImageList = [];
                    this.layoutImageList = [];
                    this.form.facilities = [];
                    this.form.gallery_images = [];
                    this.form.layout_images = [];
                }
            },

            // 返回列表
            goBack() {
                this.$router.push('/venueList');
            }
        }
    };
</script>

<style scoped>
    .venue-add-container {
        padding: 20px;
        background: linear-gradient(135deg, #f5f7fa 0%, #e8f4f8 100%);
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 12px;
        border: none;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 24px;
        border-bottom: 1px solid #f0f2f5;
        margin-bottom: 0;
        background: linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%);
        border-radius: 12px 12px 0 0;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #2c3e50;
    }

    .header-title i {
        margin-right: 10px;
        color: #409EFF;
        font-size: 22px;
    }

    .form-container {
        padding: 0 24px 24px;
        max-width: 1200px;
        margin: 0 auto;
    }

    .form-section {
        margin-bottom: 32px;
        padding: 24px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #e8e8e8;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
    }

    .form-section::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        background: linear-gradient(180deg, #409EFF 0%, #67C23A 100%);
        opacity: 0.8;
    }

    .form-section:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    }

    .section-header {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        padding-bottom: 16px;
        border-bottom: 1px solid #f0f2f5;
    }

    .section-icon {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        color: white;
        font-size: 18px;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #2c3e50;
    }

    /* 表单元素美化 */
    ::v-deep .el-form-item__label {
        font-weight: 500;
        color: #606266;
    }

    ::v-deep .el-input__inner {
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: all 0.3s ease;
    }

    ::v-deep .el-input__inner:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }

    ::v-deep .el-textarea__inner {
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: all 0.3s ease;
    }

    ::v-deep .el-textarea__inner:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }

    ::v-deep .el-select .el-input__inner {
        border-radius: 8px;
    }

    ::v-deep .el-date-editor .el-input__inner {
        border-radius: 8px;
    }

    /* 设施选择组样式 */
    .facilities-group {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        gap: 12px;
        width: 100%;
    }

    .facility-checkbox {
        margin-right: 0;
        margin-bottom: 8px;
    }

    .facility-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border: 1px solid #e8e8e8;
        border-radius: 6px;
        transition: all 0.3s ease;
        background: #fafafa;
    }

    .facility-item:hover {
        border-color: #409EFF;
        background: #f0f7ff;
    }

    .facility-item i {
        margin-right: 8px;
        color: #409EFF;
        font-size: 16px;
    }

    ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label .facility-item {
        border-color: #409EFF;
        background: #f0f7ff;
        color: #409EFF;
    }

    /* 上传组件美化 */
    .cover-upload, .gallery-upload, .layout-upload {
        width: 100%;
    }

    ::v-deep .el-upload--picture-card {
        border: 2px dashed #dcdfe6;
        border-radius: 8px;
        background-color: #fafafa;
        transition: all 0.3s ease;
    }

    ::v-deep .el-upload--picture-card:hover {
        border-color: #409EFF;
        background-color: #f0f7ff;
    }

    ::v-deep .el-upload-list--picture-card .el-upload-list__item {
        border-radius: 8px;
        border: 1px solid #e8e8e8;
    }

    /* 操作按钮区域 */
    .form-actions {
        text-align: center;
        padding: 32px 0 16px;
        margin-top: 24px;
        border-top: 1px solid #f0f2f5;
    }

    .cancel-btn {
        border-radius: 6px;
        padding: 9px 20px;
        border: 1px solid #dcdfe6;
        background: #ffffff;
        color: #606266;
        transition: all 0.3s ease;
    }

    .cancel-btn:hover {
        border-color: #409EFF;
        color: #409EFF;
        background: #f0f7ff;
    }

    .submit-btn {
        border-radius: 6px;
        padding: 9px 24px;
        background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
        border: none;
        color: white;
        transition: all 0.3s ease;
        box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
    }

    .submit-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
    }

    .reset-btn {
        border-radius: 6px;
        padding: 9px 20px;
        border: 1px solid #e6a23c;
        background: #fdf6ec;
        color: #e6a23c;
        transition: all 0.3s ease;
    }

    .reset-btn:hover {
        background: #e6a23c;
        color: white;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .venue-add-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
            padding: 16px;
        }

        .header-actions {
            margin-top: 10px;
            width: 100%;
            text-align: right;
        }

        .form-container {
            padding: 0 16px 16px;
        }

        .form-section {
            padding: 16px;
            margin-bottom: 20px;
        }

        .section-header {
            margin-bottom: 16px;
        }

        .facilities-group {
            grid-template-columns: 1fr;
        }

        .form-actions {
            padding: 24px 0 8px;
        }

        .form-actions .el-button {
            margin-bottom: 8px;
            width: 100%;
        }
    }

    /* 动画效果 */
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .form-section {
        animation: fadeInUp 0.5s ease forwards;
    }

    .form-section:nth-child(1) { animation-delay: 0.1s; }
    .form-section:nth-child(2) { animation-delay: 0.2s; }
    .form-section:nth-child(3) { animation-delay: 0.3s; }
    .form-section:nth-child(4) { animation-delay: 0.4s; }
    .form-section:nth-child(5) { animation-delay: 0.5s; }
    .form-section:nth-child(6) { animation-delay: 0.6s; }
    .form-section:nth-child(7) { animation-delay: 0.7s; }
    .form-section:nth-child(8) { animation-delay: 0.8s; }
</style>
